import React, {
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import { Toaster } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { useSelector } from "react-redux";

import barImg from "../../Images/barImg.png";

import Barcode from "react-barcode";
import { QRCodeSVG } from "qrcode.react";

import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";

import { DateToShow } from "../../Helpers/DateToShow";
import axios from "axios";


export const NewBarcodePrint = ({
    allBarcodesData,
    setAllBarcodesData,
    fieldVal,
    Txn,
    GetBarcodesById,
    PrintFN,
    PackingChallanData,
    isRatePrint,
}) => {

    console.log({ allBarcodesData })
    // ======= REDUX ======

    const { cmpdetail } = useSelector((state) => state.CompanyDetail);

    const UserDetail = useSelector((state) => state.UserDetail);

    const barcodeSettings = useSelector((state) => state.BarcodePrintSetting?.BarPrintSetting);

    const userBarcodeFormat = UserDetail?.result?.user?.vendor_barcode_formate || "";

    // == COMPANY SHORT NAME ==

    const [shortName, setShortName] = useState("");

    const getCompShortName = async () => {
        try {
            const res = await axios.get("https://application.eterp.in/company/master");
            const filtered = res.data.data.find((item) => item.key === cmpdetail?.key);
            setShortName(filtered?.short_name || "");
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getCompShortName();
    }, []);


    // ==== INNER BARCODE SETTINGS ======

    const innerBarcodeSettings = useMemo(() => {
        return Array.isArray(barcodeSettings?.Inner_Prop)
            ? barcodeSettings.Inner_Prop
            : [];
    }, [barcodeSettings]);


    // AVAILABLE BARCODE TYPES

    const availableBarcodeTypes = useMemo(() => {

        if (!barcodeSettings) {
            return [];
        }

        const typeMapping = [
            {
                key: "Barcode_Type_3825",
                value: "38x25",
            },
            {
                key: "Barcode_Type_5025",
                value: "50x25",
            },
            {
                key: "Barcode_Type_5035",
                value: "50x35",
            },
            {
                key: "Barcode_Type_5038",
                value: "38x50",
            },
            {
                key: "Barcode_Type_6040",
                value: "60x40",
            },
            {
                key: "Barcode_Type_7038",
                value: "70x38",
            },
        ];

        return typeMapping.filter((item) => barcodeSettings?.[item.key] === true).map((item) => item.value);

    }, [barcodeSettings]);


    // SELECTED BARCODE TYPE
    const [selectedBarcodeType, setSelectedBarcodeType] = useState("");


    // DEFAULT BARCODE TYPE

    useEffect(() => {
        if (!availableBarcodeTypes.length) {
            setSelectedBarcodeType("");
            return;
        }

        const userFormat = String(userBarcodeFormat).trim().toLowerCase();
        const matchedType = availableBarcodeTypes.find((type) => String(type).trim().toLowerCase() === userFormat);

        if (matchedType) {
            setSelectedBarcodeType(matchedType);
        } else {
            setSelectedBarcodeType("");
        }

    }, [userBarcodeFormat, availableBarcodeTypes,]);


    // EFFECTIVE BARCODE TYPE 

    const effectiveBarcodeType = useMemo(() => {

        if (
            selectedBarcodeType &&
            availableBarcodeTypes.includes(selectedBarcodeType)
        ) {
            return selectedBarcodeType;
        }
        return "";
    }, [selectedBarcodeType, availableBarcodeTypes,]);

    // SELECTED BARCODE SETTING 

    const selectedBarcodeSetting = useMemo(() => {
        if (!effectiveBarcodeType) {
            return null;
        }

        return (innerBarcodeSettings.find((item) => String(item?.BarcodeType || "").trim() === effectiveBarcodeType) || null);

    }, [innerBarcodeSettings, effectiveBarcodeType,]);

    // BARCODE FORMAT 
    console.log("selectedBarcodeSetting", selectedBarcodeSetting)

    const barcodeFormat = selectedBarcodeSetting?.BarcodeFormat || "";

    const isQRCode = String(barcodeFormat).trim().toLowerCase() === "format 2 - qr code".toLowerCase();

    // CURRENCY / RATE SETTINGS 

    const barcodeWithCurrency = selectedBarcodeSetting?.Barcode_With_Currency === true;

    const hideWsMrpRate = barcodeSettings?.barcode_Hide_WS_MRP_Rate === true;


    // === MODAL ==

    const [modalOpenBar, setModalOpenBar] = useState(false);

    const handleModalOpenBar = () => {
        setModalOpenBar(true);
    };

    const handleModalCloseBar = () => {
        setModalOpenBar(false);
    };


    // ========= BARCODE TYPE CHANGE ===========

    const handleBarcodeTypeChange = (event) => {

        const value = event.target.value;

        setSelectedBarcodeType(value);
    };


    // ====== BARCODE QUANTITY ==================

    const handleBarcodeQty = (event, index) => {

        const { value, name, } = event.target;
        setAllBarcodesData(
            (previousData) => {

                if (!Array.isArray(previousData)) {
                    return previousData;
                }

                return previousData.map((item, itemIndex) => {
                    if (itemIndex !== index) {
                        return item;
                    }

                    return {
                        ...item,
                        [name]: value,
                    };
                }
                );
            }
        );
    };


    // ==========
    // BARCODE CONFIGURATION
    // IMPORTANT:
    // svgWidth / svgHeight are now physical mm sizes.
    // This is better for thermal / barcode printers than
    // percentage based sizes.

    const barcodeConfig = useMemo(() => {
        switch (effectiveBarcodeType) {
            // 38 x 25
            // TWO LABELS
            // 38mm + 38mm = 76mm
            // ===
            case "38x25":
                return {
                    viewBox: "0 0 198 125",
                    pageWidth: "76mm",
                    pageHeight: "25mm",
                    svgWidth: "38mm",
                    svgHeight: "25mm",
                    // CONTENT 1
                    content1X: 99,
                    content1Y: 20,

                    // BARCODE
                    barcodeX: 28,
                    barcodeY: 24,
                    barcodeWidth: 150,
                    barcodeHeight: 42,

                    barcodeWidthValue: 1.4,
                    barcodeHeightValue: 30,

                    // BARCODE NUMBER
                    barcodeTextX: 99,
                    barcodeTextY: 70,

                    // CONTENT 2
                    content2X: 40,
                    content2Y: 84,

                    // CONTENT 3
                    content3X: 40,
                    content3Y: 101,

                    // CONTENT 4
                    content4X: 40,
                    content4Y: 119,

                    // CONTENT 5
                    content5X: 25,
                    content5Y: 63,

                    // CONTENT 6
                    content6X: 190,
                    content6Y: 68,

                    font1: 18,
                    font2: 14,
                    font3: 13,
                    font4: 14,
                    font5: 15,
                    font6: 15,

                    barcodeNumberFontSize: 11,

                    content1TextAnchor: "middle",
                    content2TextAnchor: "start",
                    content3TextAnchor: "start",
                    content4TextAnchor: "start",

                    content5TextAnchor: "middle",
                    content6TextAnchor: "middle",

                    content5Transform:
                        "rotate(-90 25 63)",

                    content6Transform:
                        "rotate(90 190 63)",

                    pair: true,
                };


            // ===
            // 50 x 25
            // TWO LABELS
            // 50mm + 50mm = 100mm
            // ===

            case "50x25":

                return {

                    viewBox: "0 0 252 125",

                    pageWidth: "100mm",
                    pageHeight: "25mm",

                    svgWidth: "50mm",
                    svgHeight: "25mm",

                    // CONTENT 1
                    content1X: 126,
                    content1Y: 18,

                    // BARCODE
                    barcodeX: 45,
                    barcodeY: 22,
                    barcodeWidth: 160,
                    barcodeHeight: 42,

                    barcodeWidthValue: 1.6,
                    barcodeHeightValue: 30,

                    // BARCODE NUMBER
                    barcodeTextX: 126,
                    barcodeTextY: 72,

                    // CONTENT 2
                    content2X: 48,
                    content2Y: 88,

                    // CONTENT 3
                    content3X: 48,
                    content3Y: 105,

                    // CONTENT 4
                    content4X: 48,
                    content4Y: 121,

                    // CONTENT 5
                    content5X: 25,
                    content5Y: 63,

                    // CONTENT 6
                    content6X: 244,
                    content6Y: 68,

                    font1: 14,
                    font2: 12,
                    font3: 11,
                    font4: 11,
                    font5: 12,
                    font6: 12,

                    barcodeNumberFontSize: 10,

                    content1TextAnchor: "middle",
                    content2TextAnchor: "start",
                    content3TextAnchor: "start",
                    content4TextAnchor: "start",

                    content5TextAnchor: "middle",
                    content6TextAnchor: "middle",

                    content5Transform:
                        "rotate(-90 25 63)",

                    content6Transform:
                        "rotate(90 244 68)",

                    pair: true,
                };

            // 50 x 35
            // TWO LABELS
            // 50mm + 50mm = 100mm


            case "50x35":

                return {

                    viewBox: "0 0 252 175",

                    pageWidth: "100mm",
                    pageHeight: "35mm",

                    svgWidth: "50mm",
                    svgHeight: "35mm",

                    // CONTENT 1
                    content1X: 128,
                    content1Y: 20,

                    // BARCODE
                    barcodeX: 45,
                    barcodeY: 25,
                    barcodeWidth: 160,
                    barcodeHeight: 52,

                    barcodeWidthValue: 1.7,
                    barcodeHeightValue: 40,

                    // BARCODE NUMBER
                    barcodeTextX: 126,
                    barcodeTextY: 85,

                    // CONTENT 2
                    content2X: 48,
                    content2Y: 105,

                    // CONTENT 3
                    content3X: 48,
                    content3Y: 128,

                    // CONTENT 4
                    content4X: 48,
                    content4Y: 151,

                    // CONTENT 5
                    content5X: 25,
                    content5Y: 87,

                    // CONTENT 6
                    content6X: 244,
                    content6Y: 98,

                    font1: 16,
                    font2: 13,
                    font3: 12,
                    font4: 12,
                    font5: 13,
                    font6: 13,

                    barcodeNumberFontSize: 11,

                    content1TextAnchor: "middle",
                    content2TextAnchor: "start",
                    content3TextAnchor: "start",
                    content4TextAnchor: "start",

                    content5TextAnchor: "middle",
                    content6TextAnchor: "middle",

                    content5Transform:
                        "rotate(-90 25 87)",

                    content6Transform:
                        "rotate(90 244 93)",

                    pair: true,
                };



            // 38 x 50
            //
            // Based on your existing code:
            // TWO labels
            // 50mm + 50mm = 100mm
            // height = 38mm

            case "38x50":

                return {

                    viewBox: "0 0 252 190",

                    // TWO LABELS SIDE BY SIDE
                    pageWidth: "76mm",
                    pageHeight: "50mm",

                    svgWidth: "38mm",
                    svgHeight: "50mm",
                    // BARCODE
                    barcodeX: 46,
                    barcodeY: 38,
                    barcodeWidth: 160,
                    barcodeHeight: 55,

                    barcodeWidthValue: 1.7,
                    barcodeHeightValue: 45,

                    // CONTENT 1
                    content1X: 126,
                    content1Y: 25,

                    // CONTENT 2
                    content2X: 126,
                    content2Y: 125,

                    // CONTENT 3
                    content3X: 126,
                    content3Y: 145,

                    // CONTENT 4
                    content4X: 126,
                    content4Y: 175,

                    // CONTENT 5
                    content5X: 18,
                    content5Y: 105,

                    // CONTENT 6
                    content6X: 238,
                    content6Y: 105,

                    font1: 15,
                    font2: 13,
                    font3: 12,
                    font4: 12,
                    font5: 13,
                    font6: 13,

                    barcodeTextX: 126,
                    barcodeTextY: 108,

                    barcodeNumberFontSize: 11,

                    content1TextAnchor: "middle",
                    content2TextAnchor: "middle",
                    content3TextAnchor: "middle",
                    content4TextAnchor: "middle",

                    content5TextAnchor: "middle",
                    content6TextAnchor: "middle",

                    content5Transform:
                        "rotate(-90 18 105)",

                    content6Transform:
                        "rotate(90 238 105)",

                    pair: true,
                };
            // 60 x 40

            // SINGLE LABEL


            case "60x40":
                return {
                    viewBox: "0 0 142 200",
                    pageWidth: "40mm",
                    pageHeight: "60mm",
                    svgWidth: "40mm",
                    svgHeight: "60mm",
                    // CONTENT 1
                    content1X: 71,
                    content1Y: 18,
                    // BARCODE
                    barcodeX: 5,
                    barcodeY: 22,
                    barcodeWidth: 132,
                    barcodeHeight: 45,
                    barcodeWidthValue: 1.4,
                    barcodeHeightValue: 28,
                    // BARCODE NUMBER
                    barcodeTextX: 71,
                    barcodeTextY: 73,
                    // CONTENT 2
                    content2X: 10,
                    content2Y: 90,
                    // CONTENT 3
                    content3X: 10,
                    content3Y: 108,
                    // CONTENT 4
                    content4X: 10,
                    content4Y: 126,
                    // CONTENT 5
                    content5X: 10,
                    content5Y: 145,
                    // CONTENT 6
                    content6X: 10,
                    content6Y: 165,

                    font1: 18,
                    font2: 14,
                    font3: 13,
                    font4: 14,
                    font5: 15,
                    font6: 15,

                    barcodeNumberFontSize: 8,

                    content1TextAnchor: "middle",
                    content2TextAnchor: "start",
                    content3TextAnchor: "start",
                    content4TextAnchor: "start",

                    content5TextAnchor: "start",
                    content6TextAnchor: "start",

                    content5Transform: "",
                    content6Transform: "",

                    pair: false,
                };

            // 70 x 38
            //
            // SINGLE LABEL


            // case "70x38":
            //     return {
            //         viewBox: "0 0 280 152",
            //         pageWidth: "70mm",
            //         pageHeight: "38mm",
            //         svgWidth: "70mm",
            //         svgHeight: "38mm",
            //         // CONTENT 1
            //         content1X: 28,
            //         content1Y: 99,
            //         // BARCODE
            //         barcodeX: 25,
            //         barcodeY: 10,
            //         barcodeWidth: 230,
            //         barcodeHeight: 55,
            //         barcodeWidthValue: 2,
            //         barcodeHeightValue: 48,
            //         // BARCODE NUMBER
            //         barcodeTextX: 140,
            //         barcodeTextY: 78,
            //         // CONTENT 2
            //         content2X: 28,
            //         content2Y: 118,
            //         // CONTENT 3
            //         content3X: 28,
            //         content3Y: 137,
            //         // CONTENT 4
            //         content4X: 28,
            //         content4Y: 150,
            //         // CONTENT 5 / 6
            //         content5X: 0,
            //         content5Y: 0,
            //         content6X: 0,
            //         content6Y: 0,
            //         font1: 18,
            //         font2: 17,
            //         font3: 15,
            //         font4: 15,
            //         font5: 12,
            //         font6: 12,
            //         barcodeNumberFontSize: 11,
            //         content1TextAnchor: "start",
            //         content2TextAnchor: "start",
            //         content3TextAnchor: "start",
            //         content4TextAnchor: "start",
            //         content5TextAnchor: "start",
            //         content6TextAnchor: "start",
            //         content5Transform: "",
            //         content6Transform: "",
            //         pair: false,
            //     };
            case "70x38":
                return {
                    viewBox: "0 0 280 152",

                    pageWidth: "70mm",
                    pageHeight: "38mm",

                    svgWidth: "70mm",
                    svgHeight: "38mm",

                    // CONTENT 1
                    content1X: 140,
                    content1Y: 18,

                    // BARCODE
                    barcodeX: 25,
                    barcodeY: 24,
                    barcodeWidth: 230,
                    barcodeHeight: 48,

                    barcodeWidthValue: 2,
                    barcodeHeightValue: 42,

                    // BARCODE NUMBER
                    barcodeTextX: 140,
                    barcodeTextY: 78,

                    // CONTENT 2
                    content2X: 48,
                    content2Y: 99,

                    // CONTENT 3
                    content3X: 48,
                    content3Y: 117,

                    // CONTENT 4
                    content4X: 48,
                    content4Y: 135,

                    // CONTENT 5 - LEFT
                    content5X: 18,
                    content5Y: 80,

                    // CONTENT 6 - RIGHT
                    content6X: 262,
                    content6Y: 80,

                    font1: 18,
                    font2: 17,
                    font3: 16,
                    font4: 16,
                    font5: 15,
                    font6: 15,

                    barcodeNumberFontSize: 11,

                    content1TextAnchor: "middle",

                    content2TextAnchor: "start",
                    content3TextAnchor: "start",
                    content4TextAnchor: "start",

                    content5TextAnchor: "middle",
                    content6TextAnchor: "middle",

                    content5Transform:
                        "rotate(-90 18 80)",

                    content6Transform:
                        "rotate(90 262 80)",

                    pair: false,
                };

            default:
                return null;
        }

    }, [effectiveBarcodeType]);


    // CONTENT RESOLVER

    const getConfiguredContent = (contentName, data) => {
        if (!contentName || !data) { return ""; }
        // HIDE RATES
        if ((contentName === "WS Rate" || contentName === "MRP Rate") && (isRatePrint || hideWsMrpRate)) { return ""; }
        // NORMALIZE NAME

        const normalizedName = String(contentName).trim().toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ");
        // CONTENT MAP

        const contentMap = {
            design: data?.Barcode_Design ?? "",
            color: data?.Barcode_Colour ?? "",
            colour: data?.Barcode_Colour ?? "",
            "design group": data?.Barcode_DesignGrp ?? "",
            department: data?.Barcode_Department ?? "",
            "set qty": data?.Barcode_SetQty ? `${selectedBarcodeSetting?.Barcode_SetQtyCaption} ${data?.Barcode_SetQty}` : "",
            "design grp": data?.Barcode_DesignGrp ?? "",
            designgrp: data?.Barcode_DesignGrp ?? "",
            "design pattern": data?.Barcode_DesignPtrn ?? "",
            "design ptrn": data?.Barcode_DesignPtrn ?? "",
            designptrn: data?.Barcode_DesignPtrn ?? "",
            pattern: data?.Barcode_DesignPtrn ?? "",
            product: data?.Barcode_Product ?? "",
            size: data?.Barcode_Size ?? "",
            "short name": shortName || "",
            "comp shortname": shortName || "",
            "comp. shortname": shortName || "",
            "company shortname": shortName || "",
            "company short name": shortName || "",
            barcode: data?.Barcode_BarcodeNo ?? "",
            "barcode no": data?.Barcode_BarcodeNo ?? "",
            "barcode number": data?.Barcode_BarcodeNo ?? "",

            // WS RATES

            "ws rate 1": fieldVal(
                "WS Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["WS L1"]
            ) ?? "",

            "ws rate 2": fieldVal(
                "WS Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["WS L1"]
            ) ?? "",

            "ws rate 3": fieldVal(
                "WS Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["WS L1"]
            ) ?? "",

            "ws rate 4": fieldVal(
                "WS Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["WS L1"]
            ) ?? "",

            "ws rate 5": fieldVal(
                "WS Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["WS L1"]
            ) ?? "",



            // MRP RATES


            "mrp rate 1": fieldVal(
                "MRP Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["MRP L1"]
            ) ?? "",

            "mrp rate 2": fieldVal(
                "MRP Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["MRP L1"]
            ) ?? "",

            "mrp rate 3": fieldVal(
                "MRP Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["MRP L1"]
            ) ?? "",

            "mrp rate 4": fieldVal(
                "MRP Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["MRP L1"]
            ) ?? "",

            "mrp rate 5": fieldVal(
                "MRP Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["MRP L1"]
            ) ?? "",

            // OLD RATE NAMES

            "ws rate": fieldVal(
                "WS Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["WS L1"]
            ) ?? "",

            wsrate: fieldVal(
                "WS Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["WS L1"]
            ) ?? "",

            "mrp rate": fieldVal(
                "MRP Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["WS L1"]
            ) ?? "",

            mrp: fieldVal(
                "MRP Rate",
                data?.Barcode_Design,
                data?.Barcode_DesignID,
                data?.Rate
                // data?.Barcode_RateChart?.["WS L1"]
            ) ?? "",
        };

        // DIRECT MAP

        if (Object.prototype.hasOwnProperty.call(contentMap, normalizedName)) {
            return contentMap[normalizedName];
        }

        // FALLBACK

        try {
            const value = fieldVal(contentName, data?.Barcode_Design, data?.Barcode_DesignID, data?.Rate);
            if (value === undefined || value === null) {
                return "";
            }
            return value;
        } catch (error) {
            console.error("Barcode content error:", contentName, error);
            return "";
        }
    };

    // BARCODE COMPONENT 

    const BarcodeComponent = ({ data, }) => {
        if (!data || !barcodeConfig || !selectedBarcodeSetting) { return null; }

        // BARCODE VALUE

        const barcodeValue = data?.Barcode_BarcodeNo || "";

        const codeValue = barcodeValue || "000000";

        // CONTENT
        const content1 = getConfiguredContent(selectedBarcodeSetting?.Barcode_Content1, data);
        const content2 = getConfiguredContent(selectedBarcodeSetting?.Barcode_Content2, data);
        const content3 = getConfiguredContent(selectedBarcodeSetting?.Barcode_Content3, data);
        const content4 = getConfiguredContent(selectedBarcodeSetting?.Barcode_Content4, data);
        const content5 = getConfiguredContent(selectedBarcodeSetting?.Barcode_Content5, data);
        const content6 = getConfiguredContent(selectedBarcodeSetting?.Barcode_Content6, data);

        // FONT SETTINGS

        const font1 = Number(selectedBarcodeSetting?.Barcode_ContentFont1) || barcodeConfig.font1;
        const font2 = Number(selectedBarcodeSetting?.Barcode_ContentFont2) || barcodeConfig.font2;
        const font3 = Number(selectedBarcodeSetting?.Barcode_ContentFont3) || barcodeConfig.font3;
        const font4 = Number(selectedBarcodeSetting?.Barcode_ContentFont4) || barcodeConfig.font4;
        const font5 = Number(selectedBarcodeSetting?.Barcode_ContentFont5) || barcodeConfig.font5;
        const font6 = Number(selectedBarcodeSetting?.Barcode_ContentFont6) || barcodeConfig.font6;

        // BARCODE NUMBER FONT

        const barcodeNumberFontSize = barcodeConfig.barcodeNumberFontSize || 11;
        // IMPORTANT DYNAMIC POSITIONING
        //
        // SVG <text> uses Y as the BASELINE.
        //
        // Therefore:
        //
        // font = 16, y = 18  -> usually okay
        //
        // font = 30, y = 18  -> top can be cropped
        //
        // We calculate a safe Y position.
        //


        const minimumContent1Y = font1 + 4;
        const content1Y = Math.max(barcodeConfig.content1Y, minimumContent1Y);

        // HOW MUCH CONTENT 1 MOVED


        const content1Shift = Math.max(0, content1Y - barcodeConfig.content1Y);

        // MOVE BARCODE DOWN
        // Only move it when CONTENT 1 actually becomes larger.


        const dynamicBarcodeY = barcodeConfig.barcodeY + content1Shift;

        // MOVE BARCODE NUMBER


        const dynamicBarcodeTextY = barcodeConfig.barcodeTextY + content1Shift;

        // MOVE CONTENT 2 / 3 / 4
        // They follow the barcode movement.

        const dynamicContent2Y = barcodeConfig.content2Y + content1Shift;

        const dynamicContent3Y = barcodeConfig.content3Y + content1Shift;

        const dynamicContent4Y = barcodeConfig.content4Y + content1Shift;

        // QR SIZE

        const qrSize = Math.min(barcodeConfig.barcodeWidth, barcodeConfig.barcodeHeight);

        // SVG

        return (
            <svg
                viewBox={barcodeConfig.viewBox}
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                /*
                 * IMPORTANT:
                 * NO BORDER HERE.
                 * Your old:
                 * border: "1px solid #ccc"
                 * was creating the gray line.
                 */

                style={{
                    background: "#fff",
                    width: barcodeConfig.svgWidth,
                    height: barcodeConfig.svgHeight,
                    display: "block",
                    flex: "0 0 auto",
                    boxSizing: "border-box",
                    border: "1px solid #ccc",
                }}

                shapeRendering="crispEdges"
            >

                {/* CONTENT 1*/}
                <text
                    x={barcodeConfig.content1X}
                    y={content1Y}
                    fontSize={font1}
                    fontWeight="600"
                    fontFamily="Verdana, sans-serif"
                    textAnchor={barcodeConfig.content1TextAnchor}
                    dominantBaseline="auto"
                >
                    {content1}
                </text>


                {/* BARCODE / QR*/}

                <foreignObject
                    x={barcodeConfig.barcodeX}
                    y={dynamicBarcodeY}
                    width={barcodeConfig.barcodeWidth}
                    height={barcodeConfig.barcodeHeight}
                >
                    <div
                        xmlns="http://www.w3.org/1999/xhtml"
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            overflow: "hidden",
                            background: "#ffffff",
                        }}
                    >

                        {isQRCode ? (
                            <QRCodeSVG
                                value={codeValue}
                                size={qrSize}
                                level="M"
                                includeMargin={false}
                                bgColor="#ffffff"
                                fgColor="#000000"
                            />

                        ) : (

                            <Barcode
                                value={codeValue}
                                format="CODE128"
                                width={barcodeConfig.barcodeWidthValue}
                                height={barcodeConfig.barcodeHeightValue}
                                renderer="svg"
                                displayValue={false}
                                margin={0}
                            />
                        )}

                    </div>

                </foreignObject>

                {/* BARCODE NUMBER*/}

                <text
                    x={barcodeConfig.barcodeTextX}
                    y={dynamicBarcodeTextY}
                    fontSize={barcodeNumberFontSize}
                    fontWeight="600"
                    fontFamily="Verdana, sans-serif"
                    textAnchor="middle"
                >
                    {barcodeValue}
                </text>


                {/* CONTENT 2*/}

                <text
                    x={barcodeConfig.content2X}
                    y={dynamicContent2Y}
                    fontSize={font2}
                    fontWeight="600"
                    fontFamily="Verdana, sans-serif"
                    textAnchor={barcodeConfig.content2TextAnchor}
                >
                    {content2}
                </text>


                {/* CONTENT 3*/}

                <text
                    x={barcodeConfig.content3X}
                    y={dynamicContent3Y}
                    fontSize={font3}
                    fontWeight="600"
                    fontFamily="Verdana, sans-serif"
                    textAnchor={barcodeConfig.content3TextAnchor}
                >
                    {content3}
                </text>


                {/* CONTENT 4*/}

                <text
                    x={barcodeConfig.content4X}
                    y={dynamicContent4Y}
                    fontSize={font4}
                    fontWeight="600"
                    fontFamily="Verdana, sans-serif"
                    textAnchor={barcodeConfig.content4TextAnchor}
                >
                    {content4}
                </text>

                {/* CONTENT 5 - LEFT*/}
                <text
                    x={barcodeConfig.content5X}
                    y={barcodeConfig.content5Y}
                    fontSize={font5}
                    fontWeight="bold"
                    fontFamily="Verdana, sans-serif"
                    textAnchor={barcodeConfig.content5TextAnchor}
                    transform={barcodeConfig.content5Transform}
                >
                    {content5}
                </text>

                {/* CONTENT 6 - RIGHT*/}

                <text
                    x={barcodeConfig.content6X}
                    y={barcodeConfig.content6Y}
                    fontSize={font6}
                    fontWeight="bold"
                    fontFamily="Verdana, sans-serif"
                    textAnchor={barcodeConfig.content6TextAnchor}
                    transform={barcodeConfig.content6Transform}
                >
                    {content6}
                </text>


                {/* 60x40 COMPANY INFORMATION*/}

                {effectiveBarcodeType ===
                    "60x40" && (
                        <>
                            <text
                                x="10"
                                y="170"
                                fontSize="6"
                                fontWeight="600"
                                fontFamily="Verdana, sans-serif"
                            >
                                MANUFACTURED AND
                                MARKETED BY:
                            </text>
                            <text
                                x="10"
                                y="180"
                                fontSize="7"
                                fontWeight="600"
                                fontFamily="Verdana, sans-serif"
                            >
                                {UserDetail?.result?.user?.company_name}
                            </text>


                            <text
                                x="10"
                                y="188"
                                fontSize="5.5"
                                fontWeight="600"
                                fontFamily="Verdana, sans-serif"
                            >
                                {UserDetail?.result?.user?.address}
                            </text>

                            <text
                                x="10"
                                y="194"
                                fontSize="5.5"
                                fontWeight="600"
                                fontFamily="Verdana, sans-serif"
                            >
                                {UserDetail?.result?.user?.mobile_no}
                            </text>


                            <text
                                x="10"
                                y="199"
                                fontSize="5"
                                fontWeight="600"
                                fontFamily="Verdana, sans-serif"
                            >
                                {UserDetail?.result?.user?.email}
                            </text>

                        </>
                    )}

            </svg>
        );
    };


    // 
    // CREATE INDIVIDUAL BARCODE LABELS
    // 

    const newBarcodesData = useMemo(() => {
        if (!Array.isArray(allBarcodesData)) {
            return [];
        }
        return allBarcodesData.reduce(
            (accumulator, item) => {
                const quantity = Number(item?.Quantity) || 0;
                for (let i = 0; i < quantity; i++) {
                    accumulator.push({ ...item, Quantity: 1, });
                }
                return accumulator;
            },
            []
        );
    }, [allBarcodesData]);

    console.log("newBarcodesData", newBarcodesData)

    // PAIR BARCODE LABELS 

    const pairedBarcodes = useMemo(() => {
        if (!barcodeConfig?.pair) {
            return [];
        }
        const result = [];
        for (let i = 0; i < newBarcodesData.length; i += 2) {
            result.push([
                newBarcodesData[i],
                newBarcodesData[i + 1] ||
                null,
            ]);
        }
        return result;
    }, [newBarcodesData, barcodeConfig,]);

    // BARCODE PRINT REF 

    const printRef = useRef(null);
    // BARCODE PRINT 

    const handlePrintBarcodes = () => {
        if (!effectiveBarcodeType) {
            showToast("No Barcode Type is selected", "error");
            return;
        }

        if (!barcodeConfig) {
            showToast(`Barcode type ${effectiveBarcodeType} is not supported`, "error");
            return;
        }


        if (!selectedBarcodeSetting) {
            showToast(`No barcode setting found for ${effectiveBarcodeType}`, "error");
            return;
        }

        if (!printRef.current) {
            return;
        }

        const printContent = printRef.current.innerHTML;
        const WinPrint = window.open("", "_blank");


        if (!WinPrint) {
            showToast("Please allow popup window for printing", "error");
            return;
        }


        WinPrint.document.write(`
            <!DOCTYPE html>
            <html>
                <head>
                    <meta charset="UTF-8" />

                    <title>
                        Barcode Print
                    </title>


                    <style>

                        @page {

                            size:
                                ${barcodeConfig.pageWidth}
                                ${barcodeConfig.pageHeight};

                            margin: 0;
                        }


                        html,
                        body {

                            margin: 0;

                            padding: 0;

                            width: 100%;

                            height: 100%;

                        }


                        body {

                            overflow: hidden;

                        }


                        .barcode-container {

                            width:
                                ${barcodeConfig.pageWidth};

                            margin: 0;

                            padding: 0;

                            display: block;

                        }


                        .barcode-row {

                            width:
                                ${barcodeConfig.pageWidth};

                            display: flex;

                            justify-content:
                                flex-start;

                            align-items:
                                flex-start;

                            gap: 0;

                            margin: 0;

                            padding: 0;

                            page-break-inside:
                                avoid;

                            break-inside:
                                avoid;

                        }


                        .barcode-row > svg {

                        flex: 0 0 auto;

                        margin: 0;

                        padding: 0;

                        border: 1px solid #e0e0e0 !important;

                        outline: none !important;

                        box-sizing: border-box;

                    }


                        svg {

                            box-sizing:
                                border-box;

                        }


                        @media print {

                            html,
                            body {

                                margin: 0 !important;

                                padding: 0 !important;

                            }


                            body * {

                                visibility:
                                    hidden !important;

                            }


                            .barcode-container,
                            .barcode-container * {

                                visibility:
                                    visible !important;

                            }


                            .barcode-container {

                                position:
                                    absolute !important;

                                left: 0 !important;

                                top: 0 !important;

                            }

                        }

                    </style>

                </head>


                <body>

                    <div
                        class="barcode-container"
                    >

                        ${printContent}

                    </div>

                </body>

            </html>

        `);


        WinPrint.document.close();


        WinPrint.onload = () => {

            WinPrint.focus();

            WinPrint.print();

            setTimeout(() => {

                WinPrint.close();

            }, 500);

        };
    };

    // FORWARDING NOTE REF

    const printRefFN = useRef(null);

    // FORWARDING NOTE PRINT 

    const handlePrintFN = () => {

        if (!printRefFN.current) { return; }

        const printContent = printRefFN.current.innerHTML;

        const WinPrint = window.open("", "_blank");

        if (!WinPrint) {
            showToast("Please allow popup window for printing", "error");
            return;
        }
        WinPrint.document.write(`

            <!DOCTYPE html>

            <html>

                <head>

                    <meta charset="utf-8" />

                    <title>
                        Forwarding Note
                    </title>


                    <link
                        href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css"
                        rel="stylesheet"
                    />


                    <link
                        rel="preconnect"
                        href="https://fonts.googleapis.com"
                    />


                    <link
                        rel="preconnect"
                        href="https://fonts.googleapis.com"
                        crossorigin
                    />


                    <link
                        href="https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700&display=swap"
                        rel="stylesheet"
                    />


                    <style>

                        body {

                            font-family:
                                "Poppins",
                                sans-serif;

                            margin: 0;

                            padding: 0;

                        }


                        .print-box {

                            width: 100%;

                            min-height: 100vh;

                            background-color:
                                #f0f2f5;

                            padding:
                                0 20px;

                            box-sizing:
                                border-box;

                        }


                        @page {

                            size:
                                101.6mm
                                152.4mm;

                            margin: 0;

                        }


                        @media print {

                            body * {

                                visibility:
                                    hidden !important;

                            }


                            .print-only,
                            .print-only * {

                                visibility:
                                    visible !important;

                            }


                            .print-only {

                                position:
                                    absolute !important;

                                left: 0;

                                top: 0;

                                width: 100%;

                            }

                        }

                    </style>

                </head>


                <body>

                    <div class="print-box">

                        <div class="print-only">

                            ${printContent}

                        </div>

                    </div>

                </body>

            </html>

        `);


        WinPrint.document.close();
        WinPrint.onload = () => {
            WinPrint.focus();
            WinPrint.print();
            setTimeout(() => {
                WinPrint.close();
            }, 500);
        };
    };

    // RENDER 

    return (
        <>

            {/* ===PRINT FN BUTTON=== */}
            {PrintFN ? (
                <Button
                    onClick={handlePrintFN}
                    variant="contained"
                    sx={{
                        width: "80px",
                    }}
                >
                    Print FN
                </Button>

            ) : !Txn ? (
                <img
                    src={barImg}
                    style={{
                        width: "50%",
                        cursor: "pointer",
                        margin: "0px 10px 0 10px",
                    }}
                    onClick={handleModalOpenBar}
                    alt="Barcode"
                />

            ) : (

                <img
                    src={barImg}
                    className="barimage"
                    onClick={() => {
                        handleModalOpenBar();
                        if (typeof GetBarcodesById === "function") {
                            GetBarcodesById();
                        }
                    }}
                    alt="Barcode"
                />

            )}

            {/* ===BARCODE DIALOG=== */}

            <Dialog

                onClose={handleModalCloseBar}
                open={modalOpenBar}
                maxWidth="md"
                fullWidth
                sx={{
                    "& .MuiDialog-paper": {
                        marginTop: "-3vh",
                    },
                }}
            >

                {/* CLOSE */}
                <IconButton
                    aria-label="close"
                    onClick={handleModalCloseBar}
                    sx={{
                        position: "absolute",
                        top: 2,
                        right: 2,
                        zIndex: 2,
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {/* HEADER */}
                <div className="d-flex justify-content-between align-items-center">
                    <DialogTitle
                        sx={{
                            pb: 0,
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                        }}
                    >
                        <span>Barcode</span>
                        {availableBarcodeTypes.length > 1 ? (
                            <TextField
                                select
                                size="small"
                                label="Barcode Type"
                                value={effectiveBarcodeType}
                                onChange={handleBarcodeTypeChange}
                                sx={{ minWidth: 140, }}
                            >
                                <MenuItem value="">
                                    <em>Select Barcode Type</em>
                                </MenuItem>
                                {availableBarcodeTypes.map(
                                    (type) => (
                                        <MenuItem key={type} value={type} >
                                            {type}
                                        </MenuItem>
                                    )
                                )}
                            </TextField>
                        ) : availableBarcodeTypes.length ===
                            1 ? (
                            <Typography
                                component="span"
                                sx={{
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: "text.secondary",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    px: 1,
                                    py: 0.5,
                                }}
                            >
                                {effectiveBarcodeType}
                            </Typography>
                        ) : (

                            <Typography
                                component="span"
                                sx={{
                                    fontSize: 13,
                                    color: "error.main",
                                }}
                            >
                                No Barcode Type
                            </Typography>
                        )}

                    </DialogTitle>

                    <DialogTitle
                        sx={{
                            pb: 0,
                            mr: 2,
                            display: "flex",
                        }}
                    >

                        <Button
                            variant="contained"
                            sx={{ marginX: 1, }}
                            onClick={handlePrintBarcodes}
                        >
                            Print Barcodes
                        </Button>
                    </DialogTitle>
                </div>


                {/* TABLE */}

                <DialogContent
                    sx={{
                        transition: "ease-in-out",
                        py: 1,
                    }}
                >

                    <TableContainer
                        component={Paper}
                        sx={{ maxHeight: "50vh", }}
                    >

                        <Table stickyHeader
                            sx={{ minWidth: 650, }}
                            size="small"
                            aria-label="barcode table"
                        >

                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 600, }} >SR#</TableCell>
                                    <TableCell sx={{ fontWeight: 600, }} >Design</TableCell>
                                    <TableCell sx={{ fontWeight: 600, }} >Barcode</TableCell>
                                    <TableCell sx={{ fontWeight: 600, }}>Qty</TableCell>
                                    <TableCell sx={{ fontWeight: 600, }}>Color</TableCell>
                                    <TableCell sx={{ fontWeight: 600, }}>Size</TableCell>
                                    <TableCell sx={{ fontWeight: 600, }}>Set Qty</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {Array.isArray(allBarcodesData) &&
                                    allBarcodesData.map((item, index) => (
                                        <TableRow key={item?.Barcode_BarcodeNo ? `${item.Barcode_BarcodeNo}-${index}` : index} >
                                            <TableCell sx={{ py: 0.5, }}>{index + 1}</TableCell>
                                            <TableCell sx={{ py: 0.5, }}>{item?.Barcode_Design}</TableCell>
                                            <TableCell sx={{ py: 0.5, }}>{item?.Barcode_BarcodeNo}</TableCell>
                                            <TableCell sx={{ py: 0.5, }} width={120}><TextField
                                                name="Quantity"
                                                label="Qty"
                                                type="number"
                                                value={item?.Quantity ?? ""}
                                                onChange={(event) => handleBarcodeQty(event, index)}
                                                InputProps={{
                                                    inputProps: {
                                                        min: 0,
                                                    },
                                                }}
                                                InputLabelProps={{
                                                    shrink:
                                                        item?.Quantity !==
                                                        undefined,
                                                }}
                                                sx={{ width: "100%", }}
                                            />
                                            </TableCell>
                                            <TableCell sx={{ py: 0.5, }}>{item?.Barcode_Colour}</TableCell>
                                            <TableCell sx={{ py: 0.5, }}>{item?.Barcode_Size}</TableCell>
                                            <TableCell sx={{ py: 0.5, }}>{item?.Barcode_SetQty || 0}</TableCell>
                                        </TableRow>
                                    )
                                    )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
            </Dialog>


            {/* ===
                HIDDEN BARCODE PRINT AREA
                === */}

            <div
                className="barcode-container"

                ref={printRef}

                style={{
                    display: "none",
                }}
            >

                {!barcodeConfig?.pair
                    ? (
                        newBarcodesData.map((element, index) => (
                            <div
                                key={index}
                                className="barcode-row"
                                style={{
                                    display: "flex",
                                    width: barcodeConfig?.pageWidth || "100%",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                    gap: 0,
                                    margin: 0,
                                    padding: 0,
                                }}
                            >
                                <BarcodeComponent data={element} />
                            </div>
                        )
                        )
                    )

                    : (pairedBarcodes.map(([element1, element2,], index) => (
                        <div
                            key={index}
                            className="barcode-row"
                            style={{
                                display: "flex",
                                width: barcodeConfig?.pageWidth || "100%",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                                gap: 0,
                                margin: 0,
                                padding: 0,
                            }}
                        >

                            {/* FIRST LABEL */}
                            <BarcodeComponent data={element1} />
                            {/* SECOND LABEL */}
                            {element2 ? (<BarcodeComponent data={element2} />) : (
                                <svg viewBox={barcodeConfig.viewBox}
                                    style={{
                                        width: barcodeConfig.svgWidth,
                                        height: barcodeConfig.svgHeight,
                                        display: "block",
                                        flex: "0 0 auto",
                                        background: "#ffffff",
                                        border: "none",
                                    }}
                                />

                            )}
                        </div>
                    )
                    )
                    )}
            </div>

            {/* === FORWARDING NOTE PRINT AREA === */}

            <div
                className="print-box"
                ref={printRefFN}
                style={{ display: "none", }}
            >

                <div className="container-fluid mt-3 print-only" >
                    {/* COMPANY HEADER */}
                    <div className="text-center">
                        <h2
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 20,
                                color: "#000",
                                fontWeight: 600,
                            }}
                        >
                            {UserDetail?.result?.user?.company_name}
                        </h2>


                        <h6
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 14,
                                color: "#000",
                                fontWeight: 500,
                                margin: 0,
                            }}
                        >

                            {UserDetail?.result?.user?.address}
                            {UserDetail?.result?.user?.address ? "," : null}
                        </h6>

                        <h6
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 14,
                                color: "#000",
                                fontWeight: 500,
                                margin: 0,
                            }}
                        >

                            {UserDetail?.result?.user?.state}{" "}
                            {UserDetail?.result?.user?.city}{" "}
                            ({UserDetail?.result?.user?.pin_code})

                        </h6>

                        <h6
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 14,
                                color: "#000",
                                fontWeight: 500,
                                margin: 0,
                            }}
                        >
                            {UserDetail?.result?.user?.mobile_no}
                        </h6>


                        <h6
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 14,
                                color: "#000",
                                fontWeight: 600,
                            }}
                        >
                            GSTNo.{" "}
                            {UserDetail?.result?.user?.GSTIN}
                        </h6>


                        <h6
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 15,
                                color: "#000",
                                fontWeight: 600,
                                margin: "5px 0 5px 0",
                                background: "#bdbdbd",
                            }}
                        >
                            FORWARDING NOTE
                        </h6>

                    </div>


                    {/* FORWARDING NOTE DETAILS */}

                    <div
                        className="box p-1 bg-transparent"
                        style={{
                            border: "1px solid #000",
                            borderRadius: "10px",
                            textAlign: "center",
                        }}
                    >
                        <div className="box rounded-0 bg-transparent border-0" >
                            <div className="row">
                                {/* DATE */}
                                <div className="text-start col-3"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 13,
                                        color: "#000",
                                    }}
                                >
                                    Date
                                </div>


                                <div
                                    className="text-start col-9"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 14,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    :&nbsp;
                                    {DateToShow(PackingChallanData?.bill_date)}
                                </div>


                                {/* BILL NO */}

                                <div
                                    className="text-start col-3"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 14,
                                        color: "#000",
                                    }}
                                >
                                    Bill No.
                                </div>


                                <div
                                    className="text-start col-9"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 15,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >

                                    :&nbsp;

                                    {PackingChallanData?.bill_no}

                                </div>


                                {/* TRANSPORT */}

                                <div
                                    className="text-start col-3"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 13,
                                        color: "#000",
                                    }}
                                >
                                    Transport
                                </div>


                                <div
                                    className="text-start col-9"

                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 14,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >

                                    :&nbsp;

                                    {PackingChallanData?.transport}

                                </div>


                                {/* DEAR SIR */}

                                <div
                                    className="text-start col-3"

                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 13,
                                        color: "#000",
                                    }}
                                >
                                    Dear Sir,
                                </div>


                                <div
                                    className="text-start col-9"

                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 12,
                                        color: "#000",
                                    }}
                                >
                                    Please book the
                                    following Consignment
                                    for delivery at
                                </div>


                                {/* CONSIGNEE */}

                                <div
                                    className="text-start col-3"

                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 13,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    M/S Consignee
                                </div>

                                <div className="text-start col-9"

                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 15,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    :&nbsp;
                                    {PackingChallanData?.is_cancel ? "" : cmpdetail?.company_name}
                                </div>


                                {/* ADDRESS */}

                                <div className="text-start col-3"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 13,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    Address
                                </div>


                                <div className="text-start col-9"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 15,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    :&nbsp;
                                    {PackingChallanData?.is_cancel ? ""
                                        : [
                                            cmpdetail?.Address,
                                            cmpdetail?.city,
                                            cmpdetail?.pin_code,
                                        ]
                                            .filter(Boolean)
                                            .join(", ")
                                    }

                                </div>


                                {/* MOBILE */}

                                <div className="text-start col-3"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 13,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    Mobile
                                </div>


                                <div className="text-start col-9"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 15,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    :&nbsp;
                                    {PackingChallanData?.is_cancel ? "" : cmpdetail?.mobile_no}
                                </div>


                                {/* GST */}

                                <div
                                    className="text-start col-3"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 13,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    <i>GST No.</i>
                                </div>


                                <div className="text-start col-9"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 14,
                                        color: "#000",
                                    }}
                                >
                                    :
                                    <i>
                                        &nbsp;
                                        {PackingChallanData?.is_cancel ? "" : cmpdetail?.gst_no}
                                    </i>

                                </div>


                                {/* PARCEL */}

                                <div className="text-start col-3"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 13,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    <i>Parcel #</i>
                                </div>

                                <div
                                    className="text-start col-3"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 17,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    :
                                    <i>
                                        &nbsp;
                                        {PackingChallanData?.is_cancel ? "" : "1"}
                                    </i>

                                </div>


                                {/* PCS */}

                                <div
                                    className="text-start col-1"

                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 13,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    <i>Pcs</i>
                                </div>


                                <div
                                    className="text-start col-5"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 14,
                                        color: "#000",
                                    }}
                                >
                                    :
                                    <i>
                                        &nbsp;
                                        {PackingChallanData?.total_quantity}
                                    </i>
                                </div>

                                {/* VALUE */}
                                <div className="text-start col-3"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 13,
                                        color: "#000",
                                        fontWeight: 600,
                                    }}
                                >
                                    <i>Value of Goods(Rs)</i>
                                </div>


                                <div
                                    className="text-start col-9"
                                    style={{
                                        fontFamily: "Poppins",
                                        fontSize: 14,
                                        color: "#000",
                                    }}
                                >
                                    :
                                    <i>
                                        &nbsp;
                                        {PackingChallanData?.totalAmount}
                                    </i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* === TOASTER=== */}
            <Toaster position="top-center" reverseOrder={false} />
        </>

    );
};